import { observer } from 'mobx-react';
import Modal from '../../../../../../../../Modal';
import RemoveParticipantStore from '../RemoveParticipantStore/Store';
import RemoveParticipantSuccess from './SuccessfullyRemoved';
import RemoveParticipantWarning from './SuccessfullyWarned';
import { emptyFragment } from '../../../../../../../../../EmptyFragment';

export interface Props {
  store: RemoveParticipantStore;
}

function RemoveParticipantModal({ store }: Props) {
  switch (store.state.kind) {
    case 'ready':
      return (
        <Modal
          close={store.closeModal}
          title={''}
          modalWidth="w-3/5 min-h-[400px]"
          customBackgroundCssClasses="bg-teal-100 opacity-60"
        >
          <RemoveParticipantWarning store={store} state={store.state} />
        </Modal>
      );
    case 'success':
      return (
        <Modal
          close={store.closeModal}
          title={''}
          modalWidth="w-3/5 min-h-[400px]"
          customBackgroundCssClasses="bg-teal-100 opacity-60"
        >
          <RemoveParticipantSuccess closeModal={store.closeModal} state={store.state} />
        </Modal>
      );
    case 'waiting':
    case 'deleting':
    case 'deleted':
    case 'failure':
    case 'error':
      return emptyFragment();
  }
}

export default observer(RemoveParticipantModal);
